import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {
  fetchDataFromLinkQueryParam,
  setNewLinkQueryParam,
  useAgentSchedulerDispatchContext, useAgentSchedulerStateContext,
} from 'Context/NewAgentSchedulerContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import SelectFieldStandardized from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';

const styles = () => ({
  root: {
    width: '20%',
    padding: '10px',
  },
});

const SchedulerPicklist = ({
  classes,
  className,
}) => {
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Monthly Calendar Agent Scheduler Picklist' });
  const { selectedAgent, schedulerAgentCollection } = useAgentSchedulerStateContext();
  const dispatch = useAgentSchedulerDispatchContext();

  const handleSchedulerAgentChange = async (option) => {
    const availabilityPeriodUrl = new URL(schedulerAgentCollection.resources().list().filter((v) => v.id() === option.target.value)[0].relationship('agentAvailabilityPeriod')
      .link('related')
      .url());
    logEvent('Set Scheduler Agent', { selectedAgentId: option.target.value });
    setNewLinkQueryParam(dispatch, availabilityPeriodUrl.toString());
    await fetchDataFromLinkQueryParam(dispatch);
  };

  return (
    <div
      {...rootNodeProps}
      className={classNames(classes.root, className)}
    >
      <SelectFieldStandardized
        test="agent-scheduler-picklist"
        label={'Select Planner'}
        options={schedulerAgentCollection ? schedulerAgentCollection.resources().list().map((item) => ({ value: item.id(), name: item.attr('agentName') })) : []}
        value={selectedAgent}
        onChange={handleSchedulerAgentChange}
      />
    </div>
  );
};

SchedulerPicklist.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  availabilityPeriodResource: PropTypes.object.isRequired,
};

SchedulerPicklist.defaultProps = {
  className: '',
};

export default withStyles(styles)(SchedulerPicklist);
